import styled from "@emotion/styled";
import { usePageView } from "src/hooks/usePageView";

const Container = styled.div`
  display: flex;
  height: 100vh;
`;

export default () => {
  usePageView("Login Confirmation");

  return (
    <Container>
      <h2>Magic Link email sent</h2>
    </Container>
  );
};
